import {getIncomeTaxValue} from "./incomeTaxCalculation";
import {getINSSDeduction} from "./inssDeductionCalculation";
import {getOtherDeduction} from "./otherDeductionCalculation";

const SIMPLIFIED_DEDUCTION_PERCENTAGE = 0.2;
const SIMPLIFIED_DEDUCTION_MAXIMUM = 16754;

const getSimplifiedDeclarationUseCase = (planning) => {
    const taxableGrossIncome = planning.grossIncome
    const supplementaryPensionContribution = 0;
    const INSS = 0;

    const simplifiedDeduction =
        taxableGrossIncome * SIMPLIFIED_DEDUCTION_PERCENTAGE;
    const otherDeduction = Math.min(simplifiedDeduction, SIMPLIFIED_DEDUCTION_MAXIMUM)
    const incomeTaxBaseValue = taxableGrossIncome - otherDeduction;
    const taxValue = getIncomeTaxValue(incomeTaxBaseValue);
    const effectiveTax = taxValue / taxableGrossIncome;

    return {
        percentageDeduction: (otherDeduction / taxableGrossIncome)*100,
        taxableGrossIncome,
        supplementaryPensionContribution,
        INSS,
        otherDeduction,
        incomeTaxBaseValue,
        effectiveTax,
        taxValue,
        incomeTaxToPay: taxValue,
        fiscalGain: 0,
    };
};

const supplementaryPensionCalc = (
    supplementaryPensionContribution,
    planning,
    simplifiedTaxValue,
  userTaxValue
) => {
    const taxableGrossIncome = planning.grossIncome
    const INSS = planning.paysINSS=== "Sim" ? getINSSDeduction(taxableGrossIncome): 0
    const {
        otherDeduction,
        dependentsDeduction,
        educationDeduction,
        medicalExpense,
        alimonyYearlyExpenses,
    } = getOtherDeduction(
        taxableGrossIncome,
        planning.dependents,
        planning.ownEducationYearlyExpenses,
        planning.averageMedicalYearlyExpenses,
        planning.alimonyYearlyExpenses,
    );
    const incomeTaxBaseValue =
        taxableGrossIncome -
        Math.min(supplementaryPensionContribution, planning.grossIncome * 0.12 ) -
        INSS -
        otherDeduction;

    const taxValue = getIncomeTaxValue(incomeTaxBaseValue);

    return {
        percentageDeduction: ((otherDeduction + INSS + Math.min(supplementaryPensionContribution, planning.grossIncome * 0.12 ))  / taxableGrossIncome)*100,
        taxableGrossIncome,
        supplementaryPensionContribution,
        INSS,
        otherDeduction,
        incomeTaxBaseValue,
        effectiveTax: taxValue / taxableGrossIncome,
        taxValue,
        yearlyTaxBreaks: 0,
        incomeTaxToPay: taxValue,
        fiscalGainFromSimplified: simplifiedTaxValue ? simplifiedTaxValue - taxValue : 0,
        fiscalGainFromUser: userTaxValue ? userTaxValue - taxValue : 0,
        dependentsDeduction,
        educationDeduction,
        medicalExpense,
        alimonyYearlyExpenses,
    };
};

const getDetailedDeclarationWithoutSupplementaryPensionUseCase = (
    planning,
  simplifiedTaxValue

) => {
    const supplementaryPensionContribution = planning.previdencyYearlyContribution;
    return supplementaryPensionCalc(supplementaryPensionContribution, planning, simplifiedTaxValue);
};

const getDetailedDeclarationWithSupplementaryPensionUseCase = (
    planning,
    simplifiedTaxValue,
    userTaxValue
) => {
    const supplementaryPensionContribution = planning.grossIncome * 0.12

    return supplementaryPensionCalc(
        supplementaryPensionContribution,
        planning,
        simplifiedTaxValue,
      userTaxValue
    );
};

export const process = (planning) => {
    const simplifiedDeclaration = getSimplifiedDeclarationUseCase(planning)

    const withUserSupplementaryPension = getDetailedDeclarationWithoutSupplementaryPensionUseCase(
      planning,
      simplifiedDeclaration.taxValue
    );

    return {
        taxableGrossIncome: simplifiedDeclaration.taxableGrossIncome,
        simplifiedDeclaration,
        withUserSupplementaryPension,
        withSupplementaryPensionMaximum: getDetailedDeclarationWithSupplementaryPensionUseCase(
          planning,
          simplifiedDeclaration.taxValue,
          withUserSupplementaryPension.taxValue
        ),
        inputtedData:planning
    };
};
